import {auth, db, fn} from '../Firebase/main';


export async function getNonce(
    publicAddress: string,
): Promise<string | null> {
    return fn
        .httpsCallable('getNonce')({
            publicAddress,
        })
        .then(({data}) => data)
        .then(({nonce}) => nonce)
        .catch(console.warn);
}


export async function verifySignature(
    publicAddress: string,
    signature: string,
): Promise<string | null> {
    return fn
        .httpsCallable('verifySignature')({
            publicAddress,
            signature,
        })
        .then(({data}) => data)
        .then(({token}) => token)
        .catch(console.warn);
}


export async function signInWithJWTAndReturnUserId(
    jwt: string,
): Promise<string | null> {
    return auth
        .signInWithCustomToken(jwt)
        .then(({user}) => user)
        .then((user) => (user ? user.uid : null))
        .catch((err) => {
            console.warn(err.message);
            return null;
        });
}


export async function handlePresence(uid: string, currentlyOn: string): Promise<any> {

    const userStatusRef = db.ref(`users/${uid}`);

    return db
        .ref('.info/connected')
        .on('value', (snapshot) => {

            if (snapshot.val() === false) {
                return;
            }

            userStatusRef
                //Disconnect Listener
                .onDisconnect()
                .update({online: false})

                //Connect Listener
                .then(() => userStatusRef.update({currentlyOn, online: true}))

                .catch(console.error);
        });
}


export async function signOut(): Promise<void> {
    if (auth.currentUser) {
        await db
            .ref('users')
            .child(auth.currentUser.uid)
            .child('online')
            .set(false);
    }
    await auth.signOut();
}


export async function changeName(name: string) {
    if (!auth.currentUser) {
        return;
    }
    await db
        .ref('users/' + auth.currentUser.uid)
        .update({name});
}
